export enum LatestNewsType {
    BUILDING_RANK_UP = "BUILDING_RANK_UP",
    HOLDER_SOLD_BUILDING = "HOLDER_SOLD_BUILDING",
    LANDLORD_SOLD_BUILDING = "LANDLORD_SOLD_BUILDING",
    LEADERBOARD_FINISHED = "LEADERBOARD_FINISHED",
    RAID_WITH_DOWNGRADE = "RAID_WITH_DOWNGRADE",
    RAID_WITH_SHIELDS = "RAID_WITH_SHIELDS",
    RENTER_POLICY_VIOLATION = "RENTER_POLICY_VIOLATION",
    RENTER_POLICY_VIOLATION_WITH_INSURANCE = "RENTER_POLICY_VIOLATION_WITH_INSURANCE",
    RETURNED_TOKENS_FOR_FIX = "RETURNED_TOKENS_FOR_FIX",
    RETURNED_TOKENS_FOR_UPGRADE = "RETURNED_TOKENS_FOR_UPGRADE",
    STEAL = "STEAL",
    VISIT = "VISIT",
    RETURNED_TOKENS_FOR_RENTER_FIX = "RETURNED_TOKENS_FOR_RENTER_FIX",
    RETURNED_TOKENS_FOR_RENTER_UPGRADE = "RETURNED_TOKENS_FOR_RENTER_UPGRADE",
    SUCCESSFUL_BUILDING_TRANSFER = "SUCCESSFUL_BUILDING_TRANSFER",
    SUCCESSFUL_DICE_ROLLS_PURCHASE = "SUCCESSFUL_DICE_ROLLS_PURCHASE",
    SUCCESSFUL_GOLDEN_WHEEL_PURCHASE = "SUCCESSFUL_GOLDEN_WHEEL_PURCHASE",
    PIGGY_CLUB_MINT_REWARD = "PIGGY_CLUB_MINT_REWARD"
}
